var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.type === "write" ? "" : "flex",
      staticStyle: { position: "relative", "padding-bottom": "60px" },
    },
    [
      _c(
        "el-card",
        { class: _vm.type === "write" ? "" : "w50" },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("after-sales::in-box::邮件信息"))),
            ]),
          ]),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "form",
              staticClass: "form-wrapper",
              class: _vm.type === "write" ? "flex" : "",
              attrs: {
                model: _vm.form,
                "label-position": "top",
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "div",
                { class: _vm.type === "write" ? "w50" : "" },
                [
                  _vm.isWrite
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("after-sales::in-box::sender"),
                            prop: "accountId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                filterable: "",
                                placeholder: _vm.$t(
                                  "after-sales::in-box::please_select"
                                ),
                              },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.form.accountId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "accountId", $$v)
                                },
                                expression: "form.accountId",
                              },
                            },
                            _vm._l(_vm.sendOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("after-sales::in-box::recipient"),
                        prop: "outUser",
                      },
                    },
                    [
                      _c("el-input", {
                        staticClass: "send-input-item",
                        attrs: {
                          placeholder: _vm.$t(
                            "after-sales::in-box::placeholder_请输入收件人"
                          ),
                        },
                        model: {
                          value: _vm.form.outUser,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "outUser", $$v)
                          },
                          expression: "form.outUser",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.isWrite
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("after-sales::in-box::bcc") },
                        },
                        [
                          _c("el-input", {
                            staticClass: "send-input-item",
                            attrs: {
                              placeholder: _vm.$t(
                                "after-sales::in-box::placeholder_请输入密送"
                              ),
                            },
                            model: {
                              value: _vm.form.bcc,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "bcc", $$v)
                              },
                              expression: "form.bcc",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("after-sales::in-box::subject"),
                        prop: "subject",
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "send-input-item",
                          attrs: {
                            placeholder: _vm.$t(
                              "after-sales::in-box::placeholder_请输入主题"
                            ),
                          },
                          model: {
                            value: _vm.form.subject,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "subject", $$v)
                            },
                            expression: "form.subject",
                          },
                        },
                        [
                          !_vm.isWrite
                            ? _c(
                                "i",
                                { attrs: { slot: "prefix" }, slot: "prefix" },
                                [_vm._v("Re:")]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("after-sales::in-box::attachment"),
                      },
                    },
                    [
                      _c("z-upload", {
                        attrs: {
                          "append-to-body": true,
                          accept: "png,jpg,xlsx,xls",
                          limit: 5,
                          multiple: true,
                        },
                        model: {
                          value: _vm.form.attachmentList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "attachmentList", $$v)
                          },
                          expression: "form.attachmentList",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  class: _vm.type === "write" ? "ml24 w50" : "",
                  attrs: { label: _vm.$t("after-sales::in-box::content") },
                },
                [
                  _c("RichEditor", {
                    attrs: {
                      height: _vm.type === "write" ? 600 : 350,
                      placeholder: _vm.$t(
                        "after-sales::in-box::content_placeholder"
                      ),
                    },
                    model: {
                      value: _vm.form.content,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "content", $$v)
                      },
                      expression: "form.content",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.type === "back"
        ? _c(
            "el-card",
            { staticClass: "w50 order-list" },
            [
              _vm._l(_vm.orders, function (item, i) {
                return _c(
                  "div",
                  { key: item.orderNo + i, staticClass: "order-item" },
                  [
                    _c("div", { staticClass: "order-info" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$t("after-sales::in-box::订单信息"))),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::order_number")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(item.orderNo)),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::shop_order_number")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.$dataCheck(item.sourceNo))),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::logistics_number")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$dataCheck(
                                item.fulfillmentTrackingNumbersString
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "after-sales::in-box::payment_serial_number"
                              )
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.$dataCheck(item.paymentNo))),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::payment_date")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.$dataCheck(item.payTime))),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(_vm.$t("after-sales::in-box::country")) +
                              "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.$dataCheck(item.country))),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "order-info" }, [
                      _c("div", { staticClass: "status-title" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::order_status")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "status" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$dataCheck(_vm.orderStatus[item.orderStatus])
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::payment_status")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$dataCheck(_vm.payStatus[item.payStatus])
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "after-sales::in-box::logistics_online_status"
                              )
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$dataCheck(
                                _vm.fulfillmentStatus[item.fulfillmentStatus]
                              )
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "info" }, [
                        _c("p", { staticClass: "name" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("after-sales::in-box::after_sale_status")
                            ) + "："
                          ),
                        ]),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$dataCheck(_vm.salesStatus[item.salesStatus])
                            )
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              _c("ZDefaultData", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.orders.length,
                    expression: "!orders.length",
                  },
                ],
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "footer-fixed",
        [
          _c(
            "el-button",
            {
              staticClass: "f-btn",
              attrs: { size: "small", type: "default" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("after-sales::in-box::btn_cancel")) + " "
              ),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "f-btn",
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.sendLoading,
              },
              on: { click: _vm.onSend },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("after-sales::in-box::btn_send")) + " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }